import { render, staticRenderFns } from "./NewProjectDialog.vue?vue&type=template&id=ed710d94"
import script from "./NewProjectDialog.vue?vue&type=script&lang=js"
export * from "./NewProjectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports